import axios from "axios";

export const getAllBlocks = () => {
  return axios.get(`https://blockchainapi.sulonya.com/api/Block/GetAllBlocks`);
};
export const getUsersBlock = () => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "get",
    url: "https://blockchainapi.sulonya.com/api/Block/GetUserBlock",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

export const getDataFromHash = (hash) => {
  return axios.get(
    `https://blockchainapi.sulonya.com/api/Block/GetBlockDataWithoutAuth?hash=${hash}`
  );
};

export const getBlockDataWithAuth = (hash) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "get",
    url: `https://blockchainapi.sulonya.com/api/Block/GetBlockDataWithAuth?hash=${hash}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
export const getBlockInformation = () =>{
  let config = {
    method: "get",
    url: `https://blockchainapi.sulonya.com/api/Block/GetBlockInformation`,
  };
  return axios(config);

}